// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu a:hover .item[data-v-21356b8c]{--bg-opacity:1;background-color:#e3e7de;background-color:rgba(227,231,222,var(--bg-opacity));--text-opacity:1;color:#3c4f28;color:rgba(60,79,40,var(--text-opacity));transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-duration:.2s}.menu[data-v-21356b8c]{top:-2rem;left:-5.5rem;background:#3c4f28}@media (min-width:1024px){.menu[data-v-21356b8c]{top:3.5rem;right:1.4rem;background:transparent}}", ""]);
// Exports
module.exports = exports;
